import React, { useState } from "react";
import { message } from "antd";
import { FiTrash2, FiAlertTriangle, FiShield, FiMail } from "react-icons/fi";
import { deleteUserByEmail } from "../../Web Apis/webApis";
import logo from "../../images/logo.jpeg";

const DeleteUserPage = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      message.warning("Please enter an email");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await deleteUserByEmail(trimmedEmail);
      if (response?.data?.success) {
        message.success(response?.data?.message || "User deleted successfully");
        setEmail("");
      } else {
        message.error(response?.data?.message || "Unable to delete user");
      }
    } catch (error) {
      console.error("Delete user failed:", error);
      message.error("Failed to delete user");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="relative overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -top-10 -left-10 h-48 w-48 rounded-full bg-white/30 blur-3xl" />
          <div className="absolute bottom-0 right-0 h-56 w-56 rounded-full bg-white/20 blur-3xl" />
        </div>
        {/* Logo at top left */}
        
        <div className="relative mx-auto  flex max-w-5xl flex-col gap-10 px-6 py-14 md:flex-row md:items-center md:justify-between">
          {/*  */}
          <div className="relative mx-auto max-w-5xl px-6 pt-6">
          <img src={logo} alt="Logo" className="h-20 w-auto object-contain" />
        </div>
          <div className="flex items-center gap-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/15 text-3xl">
              <FiTrash2 />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-white/70">
                User Management
              </p>
              <h1 className="text-3xl font-semibold md:text-4xl">
                Delete User Account
              </h1>
              <p className="mt-2 text-sm text-white/70">
                Quickly remove a user using their registered email.
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-3 text-xs text-white/80">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
              <FiShield />
              Unprotected route
            </span>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
              <FiMail />
              Email required
            </span>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-6 py-12">
        <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_320px]">
          <div className="rounded-3xl border border-slate-100 bg-white p-8 shadow-xl md:p-12">
            <div className="rounded-2xl border border-amber-100 bg-amber-50 px-4 py-3 text-sm text-amber-900">
              <div className="flex items-start gap-3">
                <FiAlertTriangle className="mt-0.5 text-lg" />
                <div>
                  <p className="font-semibold">This action is permanent.</p>
                  <p className="mt-1 text-amber-800/80">
                    Make sure the email is correct before submitting.
                  </p>
                </div>
              </div>
            </div>

            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="delete-user-email"
                  className="block text-sm font-medium text-slate-700"
                >
                  Email address
                </label>
                <div className="relative mt-2">
                  <FiMail className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    id="delete-user-email"
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="name@example.com"
                    className="w-full rounded-xl border border-slate-200 py-3 pl-11 pr-4 text-sm text-slate-800 outline-none transition focus:border-slate-400 focus:ring-2 focus:ring-slate-200"
                  />
                </div>
                <p className="mt-2 text-xs text-slate-500">
                  Use the exact email the user used to sign up.
                </p>
              </div>

              <label className="flex items-start gap-3 rounded-2xl border border-slate-100 bg-slate-50 px-4 py-3 text-sm text-slate-600">
                <input
                  type="checkbox"
                  checked={isConfirmed}
                  onChange={(event) => setIsConfirmed(event.target.checked)}
                  className="mt-1 h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-300"
                />
                <span>
                  I confirm that I want to permanently delete this user account.
                </span>
              </label>

              <button
                type="submit"
                disabled={isSubmitting || !isConfirmed}
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-400"
              >
                <FiTrash2 />
                {isSubmitting ? "Deleting..." : "Delete user"}
              </button>
            </form>
          </div>

          {/* <div className="space-y-5">
            <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-lg">
              <h2 className="text-lg font-semibold text-slate-800">
                Before you delete
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-slate-600">
                <li>Verify the email with the user.</li>
                <li>Check for any active subscriptions.</li>
                <li>Download required reports or data.</li>
              </ul>
            </div>

            <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-lg">
              <h2 className="text-lg font-semibold text-slate-800">
                What happens next
              </h2>
              <ul className="mt-4 space-y-3 text-sm text-slate-600">
                <li>The user will be removed immediately.</li>
                <li>Linked data may be deleted by the API.</li>
                <li>You can recreate the user later if needed.</li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default DeleteUserPage;
